"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSizes = exports.ProjectCertifications = exports.getCountryRegionFromLocation = exports.getProjectMapUrl = exports.ProjectSizeMapper = exports.ProjectCertificationMapper = exports.ProjectCertification = exports.ProjectSize = exports.ProjectSelector = void 0;
/**
 * General use enum for making selections of WP projects
 */
var ProjectSelector;
(function (ProjectSelector) {
    ProjectSelector["All"] = "all";
    ProjectSelector["None"] = "none";
})(ProjectSelector = exports.ProjectSelector || (exports.ProjectSelector = {}));
/**
 * 'project_size' enum from Wordpress
 */
var ProjectSize;
(function (ProjectSize) {
    ProjectSize["Small"] = "small-scale";
    ProjectSize["Medium"] = "medium-scale";
    ProjectSize["Large"] = "large-scale";
    ProjectSize["None"] = "none";
})(ProjectSize = exports.ProjectSize || (exports.ProjectSize = {}));
/**
 * 'certifications' enum as is in Wordpress
 */
var ProjectCertification;
(function (ProjectCertification) {
    ProjectCertification["CCBS"] = "ccbs";
    ProjectCertification["DNV"] = "dnv";
    ProjectCertification["GoldStandard"] = "gold-standard";
    ProjectCertification["PuroEarth"] = "puro-earth";
    ProjectCertification["VCS"] = "vcs";
})(ProjectCertification = exports.ProjectCertification || (exports.ProjectCertification = {}));
exports.ProjectCertificationMapper = {
    [ProjectCertification.CCBS]: {
        title: 'Climate, Community & Biodiversity Standard',
        tag: ProjectCertification.CCBS,
    },
    [ProjectCertification.DNV]: {
        title: 'DNV',
        tag: ProjectCertification.DNV,
    },
    [ProjectCertification.GoldStandard]: {
        title: 'Gold Standard',
        tag: ProjectCertification.GoldStandard,
    },
    [ProjectCertification.PuroEarth]: {
        title: 'Puro Earth',
        tag: ProjectCertification.PuroEarth,
    },
    [ProjectCertification.VCS]: {
        title: 'Verified Carbon Standard',
        tag: ProjectCertification.VCS,
    },
};
exports.ProjectSizeMapper = {
    [ProjectSize.None]: {
        title: 'None',
        tag: ProjectSize.None,
    },
    [ProjectSize.Small]: {
        title: 'Small',
        tag: ProjectSize.Small,
    },
    [ProjectSize.Medium]: {
        title: 'Medium',
        tag: ProjectSize.Medium,
    },
    [ProjectSize.Large]: {
        title: 'Large',
        tag: ProjectSize.Large,
    },
};
const getProjectMapUrl = (location) => {
    var _a;
    if (!(location === null || location === void 0 ? void 0 : location.latLong))
        return '';
    return `https://www.google.com/maps/d/viewer?mid=1jI22Yex9nZrXr483mkOoUZa0J70gFT5J&ll=${(_a = location.latLong) === null || _a === void 0 ? void 0 : _a[0]}%2C${location.latLong[1]}&z=12`;
};
exports.getProjectMapUrl = getProjectMapUrl;
const getCountryRegionFromLocation = (source) => {
    if (source.includes(',')) {
        const [region, country] = source.split(',').map((v) => v.trim());
        return {
            region,
            country,
        };
    }
    return { country: source };
};
exports.getCountryRegionFromLocation = getCountryRegionFromLocation;
exports.ProjectCertifications = Object.values(exports.ProjectCertificationMapper);
exports.ProjectSizes = Object.values(exports.ProjectSizeMapper);
//# sourceMappingURL=data:application/json;base64,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